import { ReactElement, SVGProps } from 'react';
import BaseIcon from './BaseIcon';

export default function AssignmentIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props} viewBox="0 0 31 31">
      <path
        d="M7.167 28a2.4 2.4 0 0 1-1.766-.734 2.4 2.4 0 0 1-.734-1.766V8q0-1.03.734-1.766A2.4 2.4 0 0 1 7.167 5.5h5.25q.406-1.125 1.36-1.812A3.57 3.57 0 0 1 15.916 3q1.187 0 2.14.688a3.75 3.75 0 0 1 1.36 1.812h5.25q1.031 0 1.765.734.735.735.735 1.766v17.5q0 1.032-.735 1.766T24.667 28zm3.75-5h6.25q.53 0 .89-.36.36-.359.36-.89t-.36-.89a1.2 1.2 0 0 0-.89-.36h-6.25q-.531 0-.89.36-.36.359-.36.89t.36.89.89.36m0-5h10q.53 0 .89-.36.36-.359.36-.89t-.36-.89a1.2 1.2 0 0 0-.89-.36h-10q-.531 0-.89.36-.36.359-.36.89t.36.89.89.36m0-5h10q.53 0 .89-.36.36-.359.36-.89t-.36-.89a1.2 1.2 0 0 0-.89-.36h-10q-.531 0-.89.36-.36.359-.36.89t.36.89.89.36m5-5.937a.9.9 0 0 0 .672-.266.9.9 0 0 0 .265-.672.9.9 0 0 0-.265-.672.9.9 0 0 0-.672-.266.9.9 0 0 0-.672.266.9.9 0 0 0-.266.672q0 .406.266.672a.9.9 0 0 0 .672.266"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
